module.exports = __webpack_public_path__ + "img/draw2_img6.17b16eec.png";